import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export default function AuthLangButton() {
  const langListRef = useRef<HTMLUListElement>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";
  const selectLanguage = (lang: "en" | "ar") => {
    i18n.changeLanguage(lang);
  };

  function langModalToggle() {
    if (!modalOpen) {
      langListRef.current?.classList.remove("h-0", "w-0");
      langListRef.current?.classList.add("h-[80px]", "w-[100px]");
      setModalOpen(true);
    } else {
      langListRef.current?.classList.remove("h-[80px]", "w-[100px]");
      langListRef.current?.classList.add("h-0", "w-0");
      setModalOpen(false);
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      langListRef.current &&
      !langListRef.current.contains(event.target as Node) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target as Node)
    ) {
      langListRef.current.classList.remove("h-[80px]", "w-[100px]");
      langListRef.current.classList.add("h-0", "w-0");
      setModalOpen(false);
    }
  };

  useEffect(() => {
    if (modalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalOpen]);

  return (
    <div
      className={`flex w-full z-[99999] items-center justify-between lg:ms-[-60px] ${
        isArabic ? "xl:translate-x-[-20px]" : ""
      } lg:w-[calc(100%+60px)]`}
    >
      <div>
        <img
          className={`w-full ${
            isArabic ? "max-w-[105px]" : "max-w-[130px]"
          } md:ps-0`}
          src={
            isArabic
              ? "/logos/auth-logo-ar.png"
              : "/logos/auth-logo-en.png"
          }
          alt="Logo"
        />
      </div>

      <div
        onClick={langModalToggle}
        ref={buttonRef}
        className={`cursor-pointer text-slate-500 ${
          isArabic ? "left-0" : "right-0"
        }`}
      >
        {t("authLangButton.language")}
        <ul
          ref={langListRef}
          className={`absolute mt-3 h-0 w-0 overflow-hidden rounded-xl bg-slate-200 text-center transition-all duration-200 ${
            isArabic ? "left-0" : "right-0"
          }`}
        >
          <li
            onClick={() => selectLanguage("en")}
            className="py-2 transition-colors duration-200 hover:bg-sidebar hover:text-skyblue"
          >
            {t("authLangButton.english")}
          </li>
          <li
            onClick={() => selectLanguage("ar")}
            className="py-2 transition-colors duration-200 hover:bg-sidebar hover:text-skyblue"
          >
            {t("authLangButton.arabic")}
          </li>
        </ul>
      </div>
    </div>
  );
}
